import { createContext } from 'react';
import utils from 'utils';

export const SAVE_STATUS = {
  IDLE: 'idle',
  SAVING: 'saving',
  SAVED: 'saved',
  FAILED: 'failed',
} as const;

export type SaveStatus = typeof SAVE_STATUS[keyof typeof SAVE_STATUS];

type SaveStatusContextProps = {
  status: SaveStatus;
  /**
   * Preview mode only, and hidden there until its first successful save.
   * Toggling between form view and preview mode starts over.
   */
  isVisible: boolean;
  /** Only true while a save has failed and a retry handler is registered. */
  canRetry: boolean;
  notifySaving: () => void;
  notifySaved: () => void;
  notifyFailed: () => void;
  /** Pass null to clear the handler once the failure is resolved. */
  registerRetry: (handler: (() => void) | null) => void;
  retry: () => void;
};

export default createContext<Partial<SaveStatusContextProps>>({
  status: SAVE_STATUS.IDLE,
  isVisible: false,
  canRetry: false,
  notifySaving: utils.noop,
  notifySaved: utils.noop,
  notifyFailed: utils.noop,
  registerRetry: utils.noop,
  retry: utils.noop,
});
